import { FC, ReactElement, useEffect } from 'react';
import { createPortal } from 'react-dom';

interface IPortal {
  children: ReactElement;
  portalId?: string;
}

const Portal: FC<IPortal> = ({ children, portalId }) => {
  const el = document.createElement('div');
  const elId = portalId || 'portal';
  const elementDOM = document.getElementById(elId);

  useEffect(() => {
    elementDOM?.appendChild(el);
    return () => {
      elementDOM?.removeChild(el);
    };
  }, []);
  return createPortal(children, el);
};

export default Portal;
